const threshold = (value, thresh) => (value < thresh ? thresh : value);

export { threshold };
